import { ConfirmPopup } from 'primereact/confirmpopup';

export default ConfirmPopup;
